<app-portal-collapsible
    [title]="title()"
    subtitle="Versichertes Gerät"
    [icon]="icon()"
    [alert]="subtitleAlert()"
>
    @if (!isComplete()) {
        <i
            collapsibleHeading
            class="c:red"
            ctrlIcon="warning"
            aria-label="Nicht vollständing"
        ></i>
    }
    <app-portal-device-details
        [device]="device()"
        [lens]="lens()"
        (submitDetails)="submit($event)"
    ></app-portal-device-details>
</app-portal-collapsible>
